import { fade, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  FilterChip: {
    display: 'flex',
    alignItems: 'center',
    '& > span': {
      marginLeft: theme.spacing(1),
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      '&.has-color': {
        display: 'flex'
      }
    }
  },
  modifyLink: {
    whiteSpace: 'nowrap',
    padding: theme.spacing(0),
    transition: 'all 0.3s ease-in-out',
    backgroundColor: 'transparent !important',
    fontWeight: theme.typography.fontWeightSemiBold,
    '&:hover': {
      color: theme.palette.secondary.main
    }
  },
  RequestHeading: {
    width: '100%',
    marginBottom: theme.spacing(2),
    fontSize: theme.typography.pxToRem(20),
    color: theme.palette.primary.main,
    '& svg': {
      marginRight: theme.spacing(1),
      fontSize: theme.typography.pxToRem(30)
    }
  },
  notificationDetailsWrapper: {
    width: '100%',
    padding: theme.spacing(3, 2, 0),
    position: 'relative',
    minHeight: 300,
  },
  RequestInfoWrapper: {
    width: '100%',
    flexWrap: 'wrap',
    display: 'flex',
    justifyContent: 'flex-start',
    position: 'relative',
    marginBottom: theme.spacing(2),
    '&.center': {
      justifyContent: 'center'
    }
  },
  infoItemWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    // fontSize: theme.typography.pxToRem(16),
    padding: theme.spacing(1.5),
    [theme.breakpoints.down('xs')]: {
      '&:nth-of-type(2n+1)': {
        backgroundColor: theme.palette.colors.table
      }
    },
    '&.no-height': {
      padding: theme.spacing(0),
      height: 0
    },
    '&:not(.attachment-item-wrapper)': {
      [theme.breakpoints.only('sm')]: {
        '&:nth-of-type(4n+1),&:nth-of-type(4n+2)': {
          backgroundColor: theme.palette.colors.table
        }
      }
    },
    [theme.breakpoints.up('md')]: {
      '&:nth-of-type(4n+1),&:nth-of-type(4n+2)': {
        backgroundColor: theme.palette.colors.table
      }
    }

  },
  infoItemLabel: {
    fontWeight: theme.typography.fontWeightBold,
    paddingRight: theme.spacing(2)
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(2),
    color: theme.palette.primary.main,
    padding: theme.spacing(0.75),
    '& .MuiSvgIcon-root': {
      fontSize: theme.typography.pxToRem(21),
      color: theme.palette.common.black
    }
  },
  DialogWrapper: {
    '& .MuiDialogActions-root': {
      padding: 0
    },
    '& .MuiDialog-paperWidthSm': {
      width: '100%',
      margin: 0,
      maxWidth: 748
    },
    '& .MuiDialogContent-root': {
      padding: theme.spacing(0)
    },
    '& .MuiDialogTitle-root': {
      margin: theme.spacing(0),
      padding: theme.spacing(2.5, 2),
      borderBottom: `1px solid #e2e8ee`,
      background: '#F6F8F3',
      display: 'flex',
      alignItems: 'center'
    }
  },
  dialogTitle: {
    fontWeight: theme.typography.fontWeightRegular,
    lineHeight: 1.3,
    marginRight: theme.spacing(5)
  },
  actionButtonsWrapper: {
    padding: theme.spacing(2),
    textAlign: 'right',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    borderTop: `1px solid ${fade(theme.palette.colors.border, 0.8)}`,
    justifyContent: 'flex-end',
    '& button': {
      lineHeight: 1.3,
      padding: theme.spacing(1.25, 2.5),
      borderRadius: theme.spacing(1.25),
      '& svg': {
        marginRight: theme.spacing(0.5)
      },
      [theme.breakpoints.up('sm')]: {
        minWidth: 140
      },
      '& + button': {
        marginLeft: theme.spacing(2)
      }
    }
  },
  cellDataWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    '& *': {
      maxWidth: 225,
      width: '100%',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis'
    },
    '& span': {
      fontSize: theme.typography.pxToRem(12)
    }
  },
}))
